/**
 * Сессии запуска пазлов из разных экранов (collection / pack):
 * используются для показа «Продолжить» vs «Пересобрать/Собрать».
 */

import { getJSON, setJSON } from './Storage';

const STORAGE_KEY = 'puzzleActionSessions';

export type PuzzleActionSource = 'collection' | 'pack';

export interface PuzzleActionSession {
  source: PuzzleActionSource;
  puzzleId: string;
  startedAt: number;
  lastUpdatedAt: number;
}

type PuzzleActionSessions = Record<string, PuzzleActionSession>;

function toKey(source: PuzzleActionSource, puzzleId: string): string {
  return `${source}:${puzzleId}`;
}

function loadSessions(): PuzzleActionSessions {
  const raw = getJSON<PuzzleActionSessions>(STORAGE_KEY);
  return raw && typeof raw === 'object' ? raw : {};
}

function saveSessions(sessions: PuzzleActionSessions): void {
  setJSON(STORAGE_KEY, sessions);
}

export function hasPuzzleActionSession(source: PuzzleActionSource, puzzleId: string): boolean {
  const sessions = loadSessions();
  return Boolean(sessions[toKey(source, puzzleId)]);
}

export function setPuzzleActionSession(source: PuzzleActionSource, puzzleId: string): void {
  const sessions = loadSessions();
  const key = toKey(source, puzzleId);
  const now = Date.now();
  const prev = sessions[key];
  sessions[key] = {
    source,
    puzzleId,
    startedAt: prev?.startedAt ?? now,
    lastUpdatedAt: now,
  };
  saveSessions(sessions);
}

export function clearPuzzleActionSession(source: PuzzleActionSource, puzzleId: string): void {
  const sessions = loadSessions();
  delete sessions[toKey(source, puzzleId)];
  saveSessions(sessions);
}

// Совместимость с текущим кодом Collection.
export function hasCollectionRebuildSession(puzzleId: string): boolean {
  return hasPuzzleActionSession('collection', puzzleId);
}

export function setCollectionRebuildSession(puzzleId: string): void {
  setPuzzleActionSession('collection', puzzleId);
}

export function clearCollectionRebuildSession(puzzleId: string): void {
  clearPuzzleActionSession('collection', puzzleId);
}
